
import { FormArray } from "@angular/forms";

export class TriggerApiCongigs {
  uId: string;
  triggertype: string;
  apiendpoint: string;
  triggerid: string;
  itemRowsURL: FormArray;
  itemRowsHead: FormArray;
  itemRowsB: FormArray;
  omitparam: boolean;
  omitfield: boolean;
  apimethod: string;
}
